// extracted by mini-css-extract-plugin
export var container = "_19-0";
export var disabled = "_19-4";
export var fullWidth = "_19-3";
export var lined = "_19-1";
export var selected = "_19-5";
export var tab = "_19-2";